import React from 'react';
import {
  Delete as DeleteIcon,
  FileCopy as DuplicateIcon,
  Visibility as ViewIcon,
  Download as DownloadIcon,
  ShareRounded,
  DownloadRounded,
  CallSplit as CallSplitIcon,
  CheckCircle as CheckCircleIcon,
  RestartAlt as RestartAltIcon,
  RefreshRounded,
  // Materials science specific icons
  ScienceRounded,
  BiotechRounded,
  BlurCircularRounded,
  LocalShippingRounded,
  Storage as StorageIcon,
  SwapHoriz as SwapHorizIcon,
  ArchiveRounded,
  CameraAltRounded,
  // Communication icons
  ChatRounded,
  // Document icons
  DescriptionRounded,
  AssignmentRounded,
  ArticleRounded,
  AssessmentRounded,
  MemoryRounded,
  AccountTreeRounded,
  RemoveRounded,
} from '@mui/icons-material';

/**
 * Icon mapping for action icons
 * Maps icon names (strings) to React components
 */
export const iconMap: Record<string, React.ReactNode> = {
  AssignmentRounded: <AssignmentRounded />,
  AssessmentRounded: <AssessmentRounded />,
  DescriptionRounded: <DescriptionRounded />,
  ArticleRounded: <ArticleRounded />,
  AccountTreeRounded: <AccountTreeRounded />,
  BlurCircularRounded: <BlurCircularRounded />,
  RefreshRounded: <RefreshRounded />,
  ScienceRounded: <ScienceRounded />,
  BiotechRounded: <BiotechRounded />,
  ArchiveRounded: <ArchiveRounded />,
  CameraAltRounded: <CameraAltRounded />,
  MemoryRounded: <MemoryRounded />,
  RemoveRounded: <RemoveRounded />,
  CallSplit: <CallSplitIcon />,
  Storage: <StorageIcon />,
  SwapHoriz: <SwapHorizIcon />,
  ChatRounded: <ChatRounded />,
  LocalShippingRounded: <LocalShippingRounded />,
  Delete: <DeleteIcon />,
  Duplicate: <DuplicateIcon />,
  CheckCircle: <CheckCircleIcon />,
  RestartAlt: <RestartAltIcon />,
  ViewIcon: <ViewIcon />,
  Download: <DownloadIcon />,
  ShareRounded: <ShareRounded />,
  DownloadRounded: <DownloadRounded />,
};
